export default __webpack_public_path__ + "static/collage_image_1-cbd7989f2986a995605783995c5efb64.jpg";